const vcComponentPkgJSON = require("@ali/vc-recept/package.json");
const renderEnginePkgJSON = require("@ali/render-engine/package.json");

module.exports = {
  vcComponentsVersion: vcComponentPkgJSON.version,
  renderEngineVersion: renderEnginePkgJSON.version,
};
